import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import CircleButton from 'components/common/components/CircleButton';
import Icons from 'consts/icons';
import { addAlert } from 'store/actions/alert/alerts';
import { authGetRequest } from 'helpers/apiRequests';
import SubscriptionsList from './SubscriptionsList';
import AddSubscription from './forms/AddSubscriptionForm';

const MainSubscriptions = props => {
  const userGroups = UserSessionDataHandler.getUserDataObject().group;
  const subtitles = useSelector(state => state.language);

  const [subscriptions, setSubscriptions] = React.useState([]);
  const [addNewSubscription, setAddNewSubscription] = React.useState(false);

  const dispatch = useDispatch();

  const apiGetSubscriptions = () => {
    authGetRequest('subscriptions').then(result => {
      if (result.status === 200) {
        setSubscriptions(result.data);
      } else
        dispatch(
          addAlert({
            title: subtitles.alerts[result.status.code].title_,
            desc: subtitles.alerts[result.status.code].desc_,
            type: 'error',
          })
        );
    });
  };

  React.useEffect(() => {
    apiGetSubscriptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {userGroups.includes('admin') ? (
        <CircleButton
          toolTipText={subtitles.adminZone.subscriptions.add_}
          onClickFunction={() => setAddNewSubscription(true)}
          PassedIcon={<Icons.Actions.Add2 />}
        />
      ) : (
        ' '
      )}

      {addNewSubscription ? (
        <AddSubscription
          goBackToMainScreen={setAddNewSubscription}
          setSubscriptions={setSubscriptions}
        />
      ) : (
        <SubscriptionsList subscriptions={subscriptions} />
      )}
    </div>
  );
};

export default MainSubscriptions;
